import Control from "../../../../../../common/Controls/Control";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROPrestationsInternationales = ({ company, activityKey }) => {
  const { updateRcproData, onBlur, errors, inputsConfig } = useRCPROQuestion({
    company,
  });
  return (
    <>
      <Control
        label={inputsConfig[activityKey + "PrestationsInternationales"].label}
        type="btnList"
        name={activityKey + "PrestationsInternationales"}
        value={company.RCPRO[activityKey + "PrestationsInternationales"]}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig[activityKey + "PrestationsInternationales"].datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      {company.RCPRO[activityKey + "PrestationsInternationales"] == 1 && (
        <>
          <Control
            label={
              inputsConfig[activityKey + "PrestationsInternationalesZones"]
                .label
            }
            type="checkBtnList"
            name={activityKey + "PrestationsInternationalesZones"}
            value={
              company.RCPRO[activityKey + "PrestationsInternationalesZones"]
            }
            change={updateRcproData}
            error={errors}
            labelClassname="w-100"
            inputGroupStyle={{ width: "100%" }}
            btnInline
            datas={
              inputsConfig[activityKey + "PrestationsInternationalesZones"]
                .datas
            }
            dataIndex="id"
            dataLabel="name"
            onBlur={onBlur}
            required
            info={<>Sélectionnez une ou plusieurs options.</>}
          />
          <Control
            label={
              inputsConfig[activityKey + "PourcentageCAInternational"].label
            }
            type="btnList"
            name={activityKey + "PourcentageCAInternational"}
            value={company.RCPRO[activityKey + "PourcentageCAInternational"]}
            change={updateRcproData}
            error={errors}
            labelClassname="w-100"
            inputGroupStyle={{ width: "100%" }}
            btnInline
            datas={
              inputsConfig[activityKey + "PourcentageCAInternational"].datas
            }
            dataIndex="id"
            dataLabel="name"
            onBlur={onBlur}
            required
          />
        </>
      )}
    </>
  );
};

export default RCPROPrestationsInternationales;
